/* eslint-disable react/jsx-props-no-spreading */
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { v4 as uuidv4 } from "uuid";
import { useContext } from "react";
import { arrRoutes, IRoutes } from "./routes";
import NotFound from "../pages/NotFound";
import { MasterPage } from "../components/MasterPage";
import Login from "../pages/Login";
import { IContainerProps } from "../typos/container";
import AppContext from "../context";

function AppRoutes() {
  const { fbUser } = useContext(AppContext);

  return (
    <BrowserRouter>
      <Routes>
        {arrRoutes
          .filter((item: IRoutes) => item.active)
          .map(({ path, isPrivate, container: Container }: IRoutes) => {
            const props: IContainerProps = {
              fbUser,
            };

            if (isPrivate && !fbUser) {
              // CREATE FORBIDDEN PAGE
              return <Route key={uuidv4()} path="/" element={<Login />} />;
            }

            return (
              <Route
                key={uuidv4()}
                path={path}
                element={
                  isPrivate ? (
                    <MasterPage>
                      <Container {...props} />
                    </MasterPage>
                  ) : (
                    <Container {...props} />
                  )
                }
              />
            );
          })}

        <Route
          path="*"
          element={
            <MasterPage>
              <NotFound />
            </MasterPage>
          }
        />
      </Routes>
    </BrowserRouter>
  );
}

export default AppRoutes;
